// extracted by extract-css-chunks-webpack-plugin
module.exports = {"errorBoxWrapper":"_2RRPnA","messageBoxWrapper":"_3e2jem","spinnerWrapper":"GoNs6L","markdown":"_3wT43M"};